import { CatalogCategory } from "./CatalogCategory";

export const INITIAL_VALUES: CatalogCategory = {
	DelayCategoryId: null,
	AssetId: null,
	DelayCategoryName: "",
	Color: "",
	IsActive: true,
	DelayCategoryColor: "",
};
